import { PrimaryButton, SecondaryButton, WithTooltip } from '@procurify/ui'

import {
  type FeatureExpansionRequestType,
  type MarketoServiceError,
} from '@webapp/core/services/Marketo'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useRequestFeatureDemoButtonPresenter } from './useRequestFeatureDemoButtonPresenter'

const toKebabCase = (str: string) => {
  return str.toLocaleLowerCase().split(' ').join('-')
}

interface IRequestFeatureDemoButtonPresenterProps {
  context: FeatureExpansionRequestType
  buttonText?: string
  variant?: 'primary' | 'secondary'
  onSuccess?: () => void
  onError?: (error: MarketoServiceError) => void
  isButtonDisabled?: boolean
}

export const RequestFeatureDemoButtonPresenter = ({
  context,
  buttonText,
  variant = 'primary',
  onSuccess,
  onError,
  isButtonDisabled,
}: IRequestFeatureDemoButtonPresenterProps) => {
  const intl = useProcurifyIntl()
  const {
    states: { isSubmitting },
    commands: { requestDemo },
  } = useRequestFeatureDemoButtonPresenter({ context, onSuccess, onError })

  const Button = variant === 'secondary' ? SecondaryButton : PrimaryButton

  return (
    <WithTooltip
      title={intl.formatMessage(messages.tooltipText)}
      isDisabled={!isButtonDisabled}
      placement='top'
    >
      <WithTooltip.Wrapper isContentDisabled={isButtonDisabled}>
        <Button
          type='button'
          onClick={requestDemo}
          isLoading={isSubmitting}
          disabled={isButtonDisabled}
          data-analytics-id={`request-${toKebabCase(context)}-feature-button`}
        >
          {buttonText ?? intl.formatMessage(messages.requestDemo)}
        </Button>
      </WithTooltip.Wrapper>
    </WithTooltip>
  )
}
